import { render, staticRenderFns } from "./CoursesTestTextHeader.vue?vue&type=template&id=febe0548&"
import script from "./CoursesTestTextHeader.vue?vue&type=script&lang=ts&"
export * from "./CoursesTestTextHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesTestTextHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports